import { baseApi as api } from './baseApi';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getHealth: build.query<GetHealthApiResponse, GetHealthApiArg>({
      query: () => ({ url: `/health` }),
    }),
    getAdevList: build.query<GetAdevListApiResponse, GetAdevListApiArg>({
      query: (queryArg) => ({
        url: `/adev/info`,
        params: {
          at: queryArg.at,
          gnss: queryArg.gnss,
        },
      }),
    }),
    getAdevByGnss: build.query<GetAdevByGnssApiResponse, GetAdevByGnssApiArg>({
      query: (queryArg) => ({
        url: `/adev/gnss/${queryArg.gnss}`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
    getIonoByType: build.query<GetIonoByTypeApiResponse, GetIonoByTypeApiArg>({
      query: (queryArg) => ({
        url: `/ionosphere/maps/${queryArg.maptype}`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
    getScintillationByGnss: build.query<
      GetScintillationByGnssApiResponse,
      GetScintillationByGnssApiArg
    >({
      query: (queryArg) => ({
        url: `/scintillation/gnss/${queryArg.gnss}`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
    getForPrNsForGnss: build.query<GetForPrNsForGnssApiResponse, GetForPrNsForGnssApiArg>({
      query: (queryArg) => ({ url: `/prn/gnss/${queryArg.gnss}` }),
    }),
    getSatellitesForPrn: build.query<GetSatellitesForPrnApiResponse, GetSatellitesForPrnApiArg>({
      query: (queryArg) => ({ url: `/prn/${queryArg.prn}` }),
    }),
    getPppByStationAndGnss: build.query<
      GetPppByStationAndGnssApiResponse,
      GetPppByStationAndGnssApiArg
    >({
      query: (queryArg) => ({
        url: `/ppp/${queryArg.code}/${queryArg.gnss}`,
        params: {
          at: queryArg.at,
        },
      }),
    }),
    getPppErrorsByStationAndGnss: build.query<
      GetPppErrorsByStationAndGnssApiResponse,
      GetPppErrorsByStationAndGnssApiArg
    >({
      query: (queryArg) => ({
        url: `/ppp/${queryArg.code}/${queryArg.gnss}/errors`,
        params: {
          at: queryArg.at,
        },
      }),
    }),
    getSatellites: build.query<GetSatellitesApiResponse, GetSatellitesApiArg>({
      query: (queryArg) => ({
        url: `/satellites`,
        params: {
          at: queryArg.at,
          gnss: queryArg.gnss,
        },
      }),
    }),
    getSatelliteByPrn: build.query<GetSatelliteByPrnApiResponse, GetSatelliteByPrnApiArg>({
      query: (queryArg) => ({
        url: `/satellites/prn/${queryArg.prn}`,
        params: {
          at: queryArg.at,
        },
      }),
    }),
    getCnrByPrnAndStation: build.query<
      GetCnrByPrnAndStationApiResponse,
      GetCnrByPrnAndStationApiArg
    >({
      query: (queryArg) => ({
        url: `/satellites/prn/${queryArg.prn}/cnr/${queryArg.code}`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
    getSatelliteByNorad: build.query<GetSatelliteByNoradApiResponse, GetSatelliteByNoradApiArg>({
      query: (queryArg) => ({ url: `/satellites/noradid/${queryArg.noradid}` }),
    }),
    getSatelliteHealthByNorad: build.query<
      GetSatelliteHealthByNoradApiResponse,
      GetSatelliteHealthByNoradApiArg
    >({
      query: (queryArg) => ({
        url: `/satellites/noradid/${queryArg.noradid}/health`,
        params: {
          msgtype: queryArg.msgtype,
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
    getSatellitesHealthChangesPerGnss: build.query<
      GetSatellitesHealthChangesPerGnssApiResponse,
      GetSatellitesHealthChangesPerGnssApiArg
    >({
      query: (queryArg) => ({
        url: `/satellites/gnss/${queryArg.gnss}/health/changes`,
        params: {
          msgtype: queryArg.msgtype,
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
    getSatellitesHealthPerGnss: build.query<
      GetSatellitesHealthPerGnssApiResponse,
      GetSatellitesHealthPerGnssApiArg
    >({
      query: (queryArg) => ({
        url: `/satellites/gnss/${queryArg.gnss}/health`,
        params: {
          msgtype: queryArg.msgtype,
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
    getTleByDatetime: build.query<GetTleByDatetimeApiResponse, GetTleByDatetimeApiArg>({
      query: (queryArg) => ({
        url: `/satellites/tles`,
        params: {
          gnss: queryArg.gnss,
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
    getTleByNoradId: build.query<GetTleByNoradIdApiResponse, GetTleByNoradIdApiArg>({
      query: (queryArg) => ({
        url: `/satellites/tles/noradid/${queryArg.noradid}`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
    getSisreByServiceAndPrn: build.query<
      GetSisreByServiceAndPrnApiResponse,
      GetSisreByServiceAndPrnApiArg
    >({
      query: (queryArg) => ({
        url: `/sisre/${queryArg.service}/${queryArg.prn}`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
    getSppByStationAndGnss: build.query<
      GetSppByStationAndGnssApiResponse,
      GetSppByStationAndGnssApiArg
    >({
      query: (queryArg) => ({
        url: `/spp/${queryArg.code}/${queryArg.gnss}`,
        params: {
          at: queryArg.at,
        },
      }),
    }),
    getSppErrorsByStationAndGnss: build.query<
      GetSppErrorsByStationAndGnssApiResponse,
      GetSppErrorsByStationAndGnssApiArg
    >({
      query: (queryArg) => ({
        url: `/spp/${queryArg.code}/${queryArg.gnss}/errors`,
        params: {
          at: queryArg.at,
        },
      }),
    }),
    getAllStations: build.query<GetAllStationsApiResponse, GetAllStationsApiArg>({
      query: (queryArg) => ({
        url: `/stations`,
        params: {
          code: queryArg.code,
        },
      }),
    }),
    getStationConfigurations: build.query<
      GetStationConfigurationsApiResponse,
      GetStationConfigurationsApiArg
    >({
      query: (queryArg) => ({
        url: `/stations/configurations`,
        params: {
          code: queryArg.code,
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
    getStationPositions: build.query<GetStationPositionsApiResponse, GetStationPositionsApiArg>({
      query: (queryArg) => ({
        url: `/stations/positions`,
        params: {
          code: queryArg.code,
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as gnssmApi };
export type GetHealthApiResponse = /** status 200 successful operation */ string;
export type GetHealthApiArg = void;
export type GetAdevListApiResponse = /** status 200 successful operation */ AdevInfo[];
export type GetAdevListApiArg = {
  /** A ISO 8601 string */
  at: string;
  /** GNSS */
  gnss?: Gnss;
};
export type GetAdevByGnssApiResponse = /** status 200 successful operation */ Adev[];
export type GetAdevByGnssApiArg = {
  /** GNSS */
  gnss: Gnss;
  /** A ISO 8601 string */
  start: string;
  /** A ISO 8601 string */
  end?: string;
};
export type GetIonoByTypeApiResponse = /** status 200 successful operation */ IonosphereMap;
export type GetIonoByTypeApiArg = {
  /** The ionosphere map type */
  maptype: IonosphereMapType;
  /** A ISO 8601 string */
  start?: string;
  /** A ISO 8601 string */
  end?: string;
};
export type GetScintillationByGnssApiResponse =
  /** status 200 successful operation */ Scintillation[];
export type GetScintillationByGnssApiArg = {
  /** GNSS */
  gnss: Gnss;
  /** A ISO 8601 string */
  start: string;
  /** A ISO 8601 string */
  end?: string;
};
export type GetForPrNsForGnssApiResponse = /** status 200 successful operation */ string[];
export type GetForPrNsForGnssApiArg = {
  /** GNSS */
  gnss: Gnss;
};
export type GetSatellitesForPrnApiResponse = /** status 200 successful operation */ Satellite[];
export type GetSatellitesForPrnApiArg = {
  /** Satellite PRN */
  prn: string;
};
export type GetPppByStationAndGnssApiResponse = /** status 200 successful operation */ Ppp[];
export type GetPppByStationAndGnssApiArg = {
  /** 4 letter code of station to return */
  code: string;
  /** GNSS */
  gnss: Gnss;
  /** A ISO 8601 string */
  at: string;
};
export type GetPppErrorsByStationAndGnssApiResponse =
  /** status 200 successful operation */ PppErrors[];
export type GetPppErrorsByStationAndGnssApiArg = {
  /** 4 letter code of station to return */
  code: string;
  /** GNSS */
  gnss: Gnss;
  /** A ISO 8601 string */
  at: string;
};
export type GetSatellitesApiResponse = /** status 200 successful operation */ Satellite[];
export type GetSatellitesApiArg = {
  /** A ISO 8601 string */
  at?: string;
  /** GNSS */
  gnss?: Gnss;
};
export type GetSatelliteByPrnApiResponse = /** status 200 successful operation */ Satellite;
export type GetSatelliteByPrnApiArg = {
  /** Satellite PRN */
  prn: string;
  /** A ISO 8601 string */
  at?: string;
};
export type GetCnrByPrnAndStationApiResponse = /** status 200 successful operation */ Cnr[];
export type GetCnrByPrnAndStationApiArg = {
  /** Satellite PRN */
  prn: string;
  /** 4 letter code of station to return */
  code: string;
  /** A ISO 8601 string */
  start: string;
  /** A ISO 8601 string */
  end: string;
};
export type GetSatelliteByNoradApiResponse = /** status 200 successful operation */ Satellite;
export type GetSatelliteByNoradApiArg = {
  /** Satellite norad id */
  noradid: number;
};
export type GetSatelliteHealthByNoradApiResponse =
  /** status 200 successful operation */ SatelliteHealth[];
export type GetSatelliteHealthByNoradApiArg = {
  /** Satellite norad id */
  noradid: number;
  /** Type of ephemeris */
  msgtype: string;
  /** A ISO 8601 string */
  start: string;
  /** A ISO 8601 string */
  end?: string;
};
export type GetSatellitesHealthChangesPerGnssApiResponse =
  /** status 200 successful operation */ SatelliteHealthRecord[];
export type GetSatellitesHealthChangesPerGnssApiArg = {
  /** GNSS */
  gnss: Gnss;
  /** Type of ephemeris */
  msgtype: string;
  /** A ISO 8601 string */
  start: string;
  /** A ISO 8601 string */
  end?: string;
};
export type GetSatellitesHealthPerGnssApiResponse =
  /** status 200 successful operation */ SatelliteHealthRecord[];
export type GetSatellitesHealthPerGnssApiArg = {
  /** GNSS */
  gnss: Gnss;
  /** Type of ephemeris */
  msgtype: string;
  /** A ISO 8601 string */
  start: string;
  /** A ISO 8601 string */
  end?: string;
};
export type GetTleByDatetimeApiResponse = /** status 200 successful operation */ Tle[];
export type GetTleByDatetimeApiArg = {
  /** GNSS */
  gnss?: Gnss;
  /** A ISO 8601 string, default two hours before end */
  start?: string;
  /** A ISO 8601 string, default is current time */
  end?: string;
};
export type GetTleByNoradIdApiResponse = /** status 200 successful operation */ Tle[];
export type GetTleByNoradIdApiArg = {
  /** A satellites norad id */
  noradid: number;
  /** A ISO 8601 string */
  start: string;
  /** A ISO 8601 string */
  end?: string;
};
export type GetSisreByServiceAndPrnApiResponse = /** status 200 successful operation */ Sisre[];
export type GetSisreByServiceAndPrnApiArg = {
  /** A service */
  service: string;
  /** Satellite PRN */
  prn: string;
  /** A ISO 8601 string */
  start: string;
  /** A ISO 8601 string */
  end?: string;
};
export type GetSppByStationAndGnssApiResponse = /** status 200 successful operation */ Spp[];
export type GetSppByStationAndGnssApiArg = {
  /** 4 letter code of station to return */
  code: string;
  /** GNSS */
  gnss: Gnss;
  /** A ISO 8601 string */
  at: string;
};
export type GetSppErrorsByStationAndGnssApiResponse =
  /** status 200 successful operation */ SppErrors[];
export type GetSppErrorsByStationAndGnssApiArg = {
  /** 4 letter code of station to return */
  code: string;
  /** GNSS */
  gnss: Gnss;
  /** A ISO 8601 string */
  at: string;
};
export type GetAllStationsApiResponse = /** status 200 successful operation */ Station[];
export type GetAllStationsApiArg = {
  /** Filter by 4 letter station code */
  code?: string;
};
export type GetStationConfigurationsApiResponse =
  /** status 200 successful operation */ StationConfiguration[];
export type GetStationConfigurationsApiArg = {
  /** Filter by 4 letter station code */
  code?: string;
  /** A ISO 8601 string */
  start?: string;
  /** A ISO 8601 string */
  end?: string;
};
export type GetStationPositionsApiResponse =
  /** status 200 successful operation */ StationPosition[];
export type GetStationPositionsApiArg = {
  /** Only return positions for 4 letter station code */
  code?: string;
  /** A ISO 8601 string */
  start?: string;
  /** A ISO 8601 string */
  end?: string;
};
export type HttpError = {
  detail?: string;
};
export type Gnss = 'galileo' | 'gps' | 'glonass' | 'beidou' | 'qzss' | 'navic' | 'sbas';
export type AdevInfo = {
  gnss: Gnss;
  station: string;
  startUtc: string;
  range: number;
  dataproduct: string;
  analysisCentre: string;
};
export type ArrayOfNumber = number[];
export type Adev = {
  info: AdevInfo;
  epochsUtc: string[];
  tau: number[];
  oadev: {
    [key: string]: ArrayOfNumber;
  };
  clockDev: {
    [key: string]: ArrayOfNumber;
  };
  clockDevRms: {
    [key: string]: number;
  };
};
export type IonosphereMapType = 'tec-measurements' | 'tec-error' | 'tec-model' | 'roti';
export type MatrixRow = number[];
export type IonosphereMap = {
  type: IonosphereMapType;
  epochUtc: string;
  map: MatrixRow[];
};
export type Scintillation = {
  prn: string;
  station: string;
  epochUtc: string;
  elevation: number;
  azimuth: number;
  s4: number;
  sigmaphi: number;
  longitude: number;
  latitude: number;
};
export type Satellite = {
  svn: string;
  prn: string;
  name: string;
  nickname?: string | null;
  gnss: Gnss;
  noradId: number;
  cosparId?: string | null;
  launchDate?: string | null;
  clock?: string | null;
  plane?: string | null;
  slot?: string | null;
  block_type?: string | null;
  signals?: string | null;
};
export type Ppp = {
  epochUtc: string;
  latitude: number;
  longitude: number;
  height: number;
  nSat: number;
};
export type PppErrors = {
  epochUtc: string;
  sdn: number | null;
  sde: number | null;
  sdu: number | null;
  sdne: number | null;
  sdeu: number | null;
  sdun: number | null;
};
export type Cnr = {
  epochUtc: string;
  signal: string;
  value: number | null;
  lli: number | null;
  ssi: number | null;
};
export type HealthStatus = 'healthy' | 'marginal' | 'unhealthy';
export type SatelliteHealth = {
  epochUtc: string;
  status: HealthStatus;
};
export type SatelliteHealthRecord = {
  noradId: number;
  msgtype: string;
  satelliteHealth: SatelliteHealth;
};
export type Tle = {
  noradId: number;
  epochUtc: string;
  line1: string;
  line2: string;
};
export type Sisre = {
  gnss: Gnss;
  epochUtc: string;
  prn: string;
  service: string;
  radial: number | null;
  along: number | null;
  cross: number | null;
  threed: number | null;
  tdash: number | null;
  drWul: number | null;
  globalAvg: number | null;
  iode: number | null;
  iodc: number | null;
  ageMin: number | null;
};
export type Spp = {
  epochUtc: string;
  latitude: number;
  longitude: number;
  height: number;
  nSat: number;
};
export type SppErrors = {
  epochUtc: string;
  sdn: number | null;
  sde: number | null;
  sdu: number | null;
  sdne: number | null;
  sdeu: number | null;
  sdun: number | null;
};
export type Station = {
  code: string;
  sitename: string;
  city: string;
  country: string;
  tectonicplate: string | null;
  retired: string | null;
  performance_monitoring: boolean;
};
export type StationConfiguration = {
  code: string;
  epochUtc: string;
  gnss: Gnss[];
  antenna: string | null;
  receiver: string | null;
  receiverFirmware: string | null;
  clockType: string | null;
  eccUp: number | null;
  eccNorth: number | null;
};
export type StationPosition = {
  code: string;
  epochUtc: string;
  x: number;
  y: number;
  z: number;
  latitude: number;
  longitude: number;
  height: number;
};
export const {
  useGetHealthQuery,
  useLazyGetHealthQuery,
  useGetAdevListQuery,
  useLazyGetAdevListQuery,
  useGetAdevByGnssQuery,
  useLazyGetAdevByGnssQuery,
  useGetIonoByTypeQuery,
  useLazyGetIonoByTypeQuery,
  useGetScintillationByGnssQuery,
  useLazyGetScintillationByGnssQuery,
  useGetForPrNsForGnssQuery,
  useLazyGetForPrNsForGnssQuery,
  useGetSatellitesForPrnQuery,
  useLazyGetSatellitesForPrnQuery,
  useGetPppByStationAndGnssQuery,
  useLazyGetPppByStationAndGnssQuery,
  useGetPppErrorsByStationAndGnssQuery,
  useLazyGetPppErrorsByStationAndGnssQuery,
  useGetSatellitesQuery,
  useLazyGetSatellitesQuery,
  useGetSatelliteByPrnQuery,
  useLazyGetSatelliteByPrnQuery,
  useGetCnrByPrnAndStationQuery,
  useLazyGetCnrByPrnAndStationQuery,
  useGetSatelliteByNoradQuery,
  useLazyGetSatelliteByNoradQuery,
  useGetSatelliteHealthByNoradQuery,
  useLazyGetSatelliteHealthByNoradQuery,
  useGetSatellitesHealthChangesPerGnssQuery,
  useLazyGetSatellitesHealthChangesPerGnssQuery,
  useGetSatellitesHealthPerGnssQuery,
  useLazyGetSatellitesHealthPerGnssQuery,
  useGetTleByDatetimeQuery,
  useLazyGetTleByDatetimeQuery,
  useGetTleByNoradIdQuery,
  useLazyGetTleByNoradIdQuery,
  useGetSisreByServiceAndPrnQuery,
  useLazyGetSisreByServiceAndPrnQuery,
  useGetSppByStationAndGnssQuery,
  useLazyGetSppByStationAndGnssQuery,
  useGetSppErrorsByStationAndGnssQuery,
  useLazyGetSppErrorsByStationAndGnssQuery,
  useGetAllStationsQuery,
  useLazyGetAllStationsQuery,
  useGetStationConfigurationsQuery,
  useLazyGetStationConfigurationsQuery,
  useGetStationPositionsQuery,
  useLazyGetStationPositionsQuery,
} = injectedRtkApi;
